// AutoMapper
import { AutoMap } from '@nartc/automapper';

// Dto
import { InsureeDto } from 'app/_mapper/insuree.dto';
import { PolicyDto } from 'app/_mapper/policy.dto';
import { CaseDetailDto } from 'app/_mapper/casedetail.dto';
import { LocationDto } from 'app/_mapper/location.dto';
import { PartyDto } from 'app/_mapper/party.dto';
import { TravelDto } from 'app/_mapper/travel.dto';

export class DossierVm {
    @AutoMap() dossierNumber: string;
    @AutoMap() intakeDuration: number;
    @AutoMap() creationDate: string;
    @AutoMap() comments: string;
    @AutoMap() agreements: string;
    @AutoMap() isUrgent: boolean;
    // @AutoMap(() => InsureeDto) insuree: InsureeDto;
    @AutoMap(() => PolicyDto) policy: PolicyDto;
    // @AutoMap(() => CaseDetailDto) caseDetail: CaseDetailDto;
    // @AutoMap(() => LocationDto) locations: LocationDto[];
    // @AutoMap(() => TravelDto) travel: TravelDto;
    // @AutoMap(() => PartyDto) parties: PartyDto[];
}
